export default __webpack_public_path__ + "static/media/item-1-mob.84d4cd27.png";